import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button
} from "@mui/material";
interface AlertDialogProps {
	isOpen: boolean;
	title: string;
	content: string;
	onClose?: () => void;
}
export const AlertDialog: React.FC<AlertDialogProps> = ({
	isOpen,
	title,
	content,
	onClose
}) => {
	return (
		<Dialog open={isOpen} onClose={onClose}>
			<DialogTitle>{title}</DialogTitle>
			<DialogContent>
				<p>{content}</p>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};
